import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useAuth } from "../../Context/AuthContext";

import "./EilatTournaments.css";

const API = process.env.REACT_APP_API;

const EilatTournaments = () => {
  const { user } = useAuth(); 
  
  const navigate = useNavigate();
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournament, setSelectedTournament] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/eilatTournaments`)
      .then((res) => res.json())
      .then((data) => {
        setTournaments(data);
        if (data.length > 0) setSelectedTournament(data[0]); // ברירת מחדל: הראשון
      })
      .catch((err) =>
        console.error("שגיאה בשליפת רשימת טורנירי אילת:", err)
      );
  }, []);

  const loadTournamentDetails = async (id) => {
    try {
      const res = await axios.get(
        `${API}/api/eilatTournaments/${id}`
      );
      setSelectedTournament(res.data);
    } catch (err) {
      console.error("שגיאה בשליפת פרטי טורניר:", err);
    }
  };

  return (
    <div className="eilat-tournaments">
      {/* כפתורים עליונים */}
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")}/>
      </div>

      {/* פרטי טורניר */}
      <div className="tournament-details">
        {selectedTournament ? (
          <>
            <h2>
              {selectedTournament.name}
            </h2>

            {selectedTournament.showFlyer && selectedTournament.flyer && (
              <img
                src={selectedTournament.flyer}
                alt={`פלייר ${selectedTournament.name}`}
                className="flyer"
              />
            )}

            <div className="tournament-actions">
              {selectedTournament.pdfLink && (
              <a
                href={selectedTournament.pdfLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn pdf-btn"
                style={{ marginLeft: "10px" }}
              >
                📄 חוזר רישום
              </a>
            )}

              {selectedTournament.showRegistration && (
                <a
                  href={
                    selectedTournament.registrationLink?.trim() !== ""
                      ? selectedTournament.registrationLink
                      : "https://example.com/default-registration"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  הרשמה
                </a>
              )}

              {selectedTournament.showFacebook && (
                <a
                  href={
                    selectedTournament.facebookLink?.trim() !== ""
                      ? selectedTournament.facebookLink
                      : "https://facebook.com/default-page"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  פייסבוק
                </a>
              )}
            </div>

            {selectedTournament.showGallery && (
              <div className="gallery">
                {(selectedTournament.gallery || []).map((img, idx) => (
                  <img
                    key={idx}
                    src={
                      img.data
                        ? {img}
                        : `${API}${img.url || "/images/default-gallery.jpg"}`
                    }
                    alt={`תמונה ${idx}`}
                  />
                ))}
              </div>
            )}

            {user?.isAdmin && (
            <>
              <p className="status">
                סטטוס:{" "}
                {selectedTournament.showOnSite
                  ? "✅ מוצג למבקרים"
                  : "❌ מוסתר ממבקרים"}
              </p>

              <Link
                to={`/eilatTournaments/edit/${selectedTournament._id}`}
                className="btn edit-btn"
              >
                ✏️ עריכה
              </Link>
            </>
            )}
          </>
        ) : (
          <p>אין טורניר להצגה</p>
        )}
      </div>

      {/* סרגל תחתון */}
      <div className="eilat-tabs">
        <h3>קודמים <FaArrowLeft /></h3>
        {user?.isAdmin && (
          <Link to="/eilatTournaments/new" className="btn add-btn" title="הוספת טורניר">
            ➕
          </Link>
        )}
        {tournaments.length === 0 ? (
          <p className="no-tournaments">אין טורנירים להצגה</p>
        ) : (
        tournaments
        .filter(t => user?.isAdmin || t.showOnSite) // 👈 רק אדמין רואה הכל, משתמש רגיל רואה רק כאלה שמסומנים להצגה
        .sort((a, b) => new Date(b.year) - new Date(a.year))
        .map((tournament) => (
          <button
            key={tournament._id}
            className={`tournament-item ${selectedTournament?._id === tournament._id ? "selected" : ""}`}
            onClick={() => loadTournamentDetails(tournament._id)}
          >
            {tournament.name}
          </button>
        )))
        }
      </div>
    </div>
  );
};

export default EilatTournaments;
